const showName = () => {
  if (typeof process.env.REACT_APP_DOMAIN_NAME !== 'undefined') {
    return process.env.REACT_APP_DOMAIN_NAME;
  }
  const url = window.location.hostname;
  return url.split('.')[0];
};

export default showName;
